import { render, staticRenderFns } from "./LawNormTable.vue?vue&type=template&id=2d10be40&scoped=true&"
import script from "./LawNormTable.vue?vue&type=script&lang=js&"
export * from "./LawNormTable.vue?vue&type=script&lang=js&"
import style0 from "./LawNormTable.vue?vue&type=style&index=0&id=2d10be40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10be40",
  null
  
)

export default component.exports